import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        registration: {
          module: () => import('./registration.module').then((m) => m.RegistrationModule),
          cmsComponents: ['CmsRegistrationComponent'],
        },
      },
    }),
  ],
})
export class RegistrationFeatureModule {}
